'use strict';

var React = require('react');

var SvgReportMinor = function SvgReportMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.25a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.5a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14.25v-3.5a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 2.5a2.75 2.75 0 0 0-2.75 2.75v9.5a2.75 2.75 0 0 0 2.75 2.75h6.5a2.75 2.75 0 0 0 2.75-2.75v-6.25a.75.75 0 0 0-.22-.53l-5.25-5.25a.75.75 0 0 0-.53-.22h-3.25Zm-1.25 2.75c0-.69.56-1.25 1.25-1.25h2.5v3.5c0 .966.784 1.75 1.75 1.75h3.5v5.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-9.5Zm7.94 2.5-2.69-2.69v2.44c0 .138.112.25.25.25h2.44Z"
  }));
};
SvgReportMinor.displayName = "ReportMinor";

exports.SvgReportMinor = SvgReportMinor;
